var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.009,
    height: 47.637,
    viewBox: "0 0 96.009 47.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M.446,46.871H8.386v-33.8H.446ZM4.4,8.641A4.322,4.322,0,1,0,4.4,0a4.321,4.321,0,1,0,0,8.641ZM34.82.1C21.4.1,12.978,9.246,12.978,23.882S21.4,47.637,34.82,47.637c13.392,0,21.81-9.119,21.81-23.755S48.212.1,34.82.1Zm0,7.015c8.194,0,13.423,6.5,13.423,16.772,0,10.235-5.229,16.74-13.423,16.74-8.226,0-13.423-6.5-13.423-16.74,0-10.267,5.2-16.772,13.423-16.772ZM59.978,33.926c.351,8.482,7.3,13.711,17.887,13.711,11.128,0,18.143-5.484,18.143-14.221,0-6.855-3.954-10.713-13.3-12.85L77.42,19.355c-5.644-1.339-7.971-3.125-7.971-6.186,0-3.826,3.507-6.377,8.7-6.377,5.261,0,8.864,2.583,9.247,6.887h7.844C95.052,5.58,88.356.1,78.217.1,68.2.1,61.094,5.612,61.094,13.775c0,6.568,4.018,10.65,12.5,12.595l5.963,1.4c5.8,1.371,8.163,3.284,8.163,6.6,0,3.826-3.858,6.568-9.406,6.568-5.612,0-9.852-2.774-10.362-7.015H59.979Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.ff91704e2da6d40d8dfce262dd66d6c2.svg";
export { ForwardRef as ReactComponent };